import React from 'react';

import classes from './spinner.css';

const spinner = (props) => {

    const loader = (props.small) ? [classes.Loader, classes.small] : [classes.Loader];

    if (props.apiError) return (<div className={classes.errorBox}>
        <i className="fas fa-exclamation-triangle"></i>
        There was a problem fetching your data
        <p className={classes.errorSubMessage}>Please refresh the page or try again in a short while</p>
    </div>);

    if (props.noAccounts) return (<div className={classes.errorBox}>
        <i className="fas fa-exclamation-triangle"></i>
        There are no linked bank accounts
    </div>);

    return <div className={loader.join(' ')}>Loading...</div>;
}

export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/spinner.js